import { formatValue } from "./format_value";

export function janeeChart(config) {
  const primary = config.datasets[0];
  const secondary = config.datasets[1];

  const datasets = [
    ...(secondary ? [{
      type: 'line',
      pointStyle: 'triangle',
      pointRotation: 180,
      borderWidth: 0,
      pointRadius: 7,
      hoverRadius: 9,
      label: secondary.title,
      data: calculateJaNeeData(primary.data, secondary.data),
      backgroundColor: '#e34c22',
      tooltip: {
        callbacks: {
          label: function(context) {
            var janee = (context.parsed.x < 1) ? 'ja' : 'nee';
            return secondary.title + ': ' + janee
          }
        }
      }
    }] : []),
    {
      type: 'bar',
      label: 'ja',
      data: primary.data.ja,
      backgroundColor: '#dfb829',
    },
    {
      type: 'bar',
      label: 'nee',
      data: primary.data.nee,
      backgroundColor: '#dddddd',
    }
  ];

  return {
    data: {
      labels: primary.data.labels,
      datasets: datasets
    },
    options: {
      indexAxis: 'y',
      locale: 'nl-NL',
      maintainAspectRatio: false,
      plugins: {
        tooltip: {
          callbacks: {
            label: function(context) {
              return 'aantal kantoren "' + context.dataset.label + '": ' + context.formattedValue
            }
          }
        }
      },
      scales: {
        x: {
          stacked: true,
          ticks: {
            callback: function(value) {
              return formatValue(value, config.options.format, config.options.fractionDigits || 0);
            }
          }
        },
        y: {
          stacked: true,
          ticks: {
            crossAlign: 'far',
          }
        }
      },
      interaction: {
        mode: 'index',
      }
    }
  }
}

// calculate the location for "this office" on the ja/nee bar chart
// - if a value is 1 in the ja array, it should at 0.5 (left side)
// - if a value is 1 in the nee array, it should be at 0.5 under the total (right side)
function calculateJaNeeData(allData, thisData) {
  const transformedData = [];

  for (let i = 0; i < thisData.ja.length; i++) {
    if (thisData.ja[i] === 1) {
      transformedData.push(0.5);
    } else if (thisData.nee[i] === 1) {
      transformedData.push(allData.ja[i] + allData.nee[i] - 0.5);
    } else {
      transformedData.push(null);
    }
  }

  return transformedData;
}
